import React from "react";

import { OverlayTrigger, Popover } from "react-bootstrap";
import "./index.scss";
import { useWindowSize } from "../../../../hooks/use-device-type";

export interface SvgCompExamProps {}

export function SvgCompExam(props: SvgCompExamProps) {
  const { isMobile } = useWindowSize();
  const placement = isMobile ? "top" : "right-start";

  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Popover id="svg-comp-exam">
          <Popover.Body>
            <h3>核心：品类丰富和顶级标准</h3>

            <ul>
              <li>2500余项国际资质认证考试；</li>
              <li>国际顶级行业标准和规格；</li>
              <li>成绩全球第一。</li>
            </ul>
          </Popover.Body>
        </Popover>
      }
    >
      <g className="svg-comp-piece">
        <path
          xmlns="http://www.w3.org/2000/svg"
          fill="#7030a0"
          d="M 405.5,287.5 C 427.39,301.699 449.224,316.032 471,330.5C 492.582,318.293 514.082,305.96 535.5,293.5C 533.229,345.813 516.729,393.146 486,435.5C 463.432,466.411 435.599,491.244 402.5,510C 406.02,516.896 408.52,524.063 410,531.5C 384.31,510.976 358.477,490.643 332.5,470.5C 335.591,435.44 339.924,400.44 345.5,365.5C 348.283,371.008 350.783,376.674 353,382.5C 372.401,367.383 386.734,348.383 396,325.5C 400.433,313.103 403.599,300.437 405.5,287.5 Z"
        />

        <text x={390} y={420} fontSize={60} fill="#fff" fontWeight={"bold"}>
          考
        </text>
      </g>
    </OverlayTrigger>
  );
}
